module.exports = __webpack_public_path__ + "img/list.b72af44c.svg";